__turbopack_context__.v({
  "loginForm": "styles-module-scss-module__rTHqJG__loginForm",
  "loginForm__content": "styles-module-scss-module__rTHqJG__loginForm__content",
  "loginForm__content_form": "styles-module-scss-module__rTHqJG__loginForm__content_form",
  "loginForm__content_title": "styles-module-scss-module__rTHqJG__loginForm__content_title",
  "loginForm__footer": "styles-module-scss-module__rTHqJG__loginForm__footer",
  "loginForm__logo": "styles-module-scss-module__rTHqJG__loginForm__logo",
});
